import React, {useCallback, useMemo, useState} from 'react'
import {useTranslation} from "react-i18next";
import {ModalSubscriptionRenew, ModalSubscriptionUpdate} from "../modals";
import {hasPermission} from "../../redux/reducers/user";
import {useAppSelector} from "../../redux/store";
import {ButtonSecondary, LinkButton} from "../button";
import {FaSkype, FaTelegram} from "react-icons/fa";
import {DetailContainer, DetailLabel, DetailValue} from "../modals/modal.withdraw";
import styled from "styled-components";
import {AlertInfoText} from "../alert";

const TeamSubscriptionContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    
    &.table-view-mode {
        gap: 8px;
    }
`

const TeamDetailsConts = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
    gap: 12px;
`

const SubscriptionServicesContainer = styled.div`
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;

    &.table-view-mode {
        margin: 10px 0;
        gap: 8px;
    }
`

const ServiceContainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 8px;
    align-self: stretch;
`
const ServiceInfoText = styled.p`
    color: var(--it-text-white);

    /* Menu items */
    font-family: "Basis Grotesque Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 19.2px */
    letter-spacing: 0.48px;

    &[data-red] {
        color: var(--it-text-red);
    }
`

export function SubscriptionServices({services, usedServices, isInTableViewMode}){
    const {t} = useTranslation();
    return (
        <SubscriptionServicesContainer className={isInTableViewMode ? 'table-view-mode' : ''}>
            {Object.keys(services?.apps_count).map((appType, idx)=>{
                    let serviceCount = usedServices?.apps_count && (usedServices.apps_count[appType] || 0);

                    return (
                      <ServiceContainer key={appType}>
                        <ServiceInfoText>
                            {t(`resource_page.app.field.app_type_${appType}`)}:
                        </ServiceInfoText>
                        <ServiceInfoText {...(services?.apps_count[appType] > 0 && serviceCount >= services?.apps_count[appType] ? { "data-red": true } : {})}>
                            {usedServices?.apps_count && `${serviceCount} / `}{services?.apps_count[appType] == -1 ? t(`resource_page.subscription.field.unlimited`) : services?.apps_count[appType]}
                        </ServiceInfoText>
                      </ServiceContainer>
                    )
                })}
        </SubscriptionServicesContainer>
    )
}

function SubscriptionDetails({title, price, isActive, dateEnd, services, usedServices, isInTableViewMode}){
    const {t} = useTranslation();
    const {settings} = useAppSelector();
    const daysToExpire = useMemo(()=>{
        if(!dateEnd) return 0;
        let difference = (new Date(dateEnd)).getTime() - (new Date()).getTime();
        return Math.ceil(difference / (1000 * 3600 * 24));
    }, [dateEnd])

    return (
      <>
        <TeamDetailsConts>
          <DetailContainer>
            <DetailLabel>
              {title}
            </DetailLabel>
            {settings.monetization_active && (
              <DetailValue>
                ${price}
              </DetailValue>
            )}
          </DetailContainer>

          <DetailContainer>
            <DetailLabel {...(isActive ? {} : { "data-red": true })}>
              {t(isActive ? `team_subscription.ending_on` : `team_subscription.expired`)}
            </DetailLabel>
            <DetailValue {...(isActive ? {} : { "data-red": true })}>
              {dateEnd}
            </DetailValue>
          </DetailContainer>
        </TeamDetailsConts>

        <>
          <SubscriptionServices services={services}
                                usedServices={usedServices}
                                isInTableViewMode={isInTableViewMode}
          />
        </>
      </>
    )

    /*return (
        <div className={`my-2`}>
            <div className={`flex flex-row space-x-8`}>
                <div className={`flex flex-col my-1`}>
                    <div className={`font-bold`}>{title}</div>
                    {settings.monetization_active && <div className={`text-sm font-medium`}>${price}</div>}
                </div>
                <div className={`flex flex-col my-1`}>
                    <div className={`${daysToExpire > 10 ? `text-green-500` : ( daysToExpire > 5 ? `text-orange-500` : `text-red-500`)} font-semibold uppercase`}>{isActive ? `ENDING ON` : `Expired`}</div>
                    <div className={`text-sm font-medium`}>{dateEnd}</div>
                </div>
            </div>

            <div className={`my-2`}>
                <SubscriptionServices services={services} usedServices={usedServices} />
            </div>

        </div>
    )*/
}

function SubscriptionPPI(){
    const {t} = useTranslation();

    return (
      <>
          <AlertInfoText style={{marginTop: '0'}}>
              {t(`team_subscription.type_ppi`)}
          </AlertInfoText>
      </>
    )

    /*return (
        <div className={`my-2`}>
            {/!*<a className="text-green-800"*!/}
            {/!*   href="/tariffs"*!/}
            {/!*   target="_blank">TARIFFS</a>*!/}
        </div>
    )*/
}

function SubscriptionNotActive() {
    // TODO: check if this scenario is necessary (not used now)
    // if 'yes' - redesign and activate according to the technical task
    const {t} = useTranslation();
    const {settings} = useAppSelector();
    return (
        <div className={`text-center p-4`}>
            {t(`team_subscription.write_to_manager`)}

            <div className={`pt-2 flex flex-row flex-wrap justify-center gap-4`}>
                {settings.manager?.tg &&
                    <LinkButton to={`https://t.me/${settings.manager.tg}`} target={`_blank`} title={`@${settings.manager.tg}`} icon={<FaTelegram className="stroke-current mr-2"/>}
                                className="mb-4" />}
                {settings.manager?.skype &&
                    <LinkButton to={`skype:${settings.manager.skype}?chat`} target={`_blank`} title={`@${settings.manager.skype}`} icon={<FaSkype className="stroke-current mr-2"/>}
                                className="mb-4" />}
            </div>
        </div>
    )
}

export function TeamSubscription({
                                     teamId,
                                     id: subscriptionId,
                                     is_active: isActive,
                                     title,
                                     date_end: dateEnd,
                                     price,
                                     services,
                                     usedServices,
                                     onSubscriptionUpdate,
                                     isInTableViewMode = false,
}){
    const {t} = useTranslation();
    const {user, settings} = useAppSelector();
    const [isModalSubscriptionUpdateVisible, setModalSubscriptionUpdateVisible] = useState(false);
    const [isModalSubscriptionRenewVisible, setModalSubscriptionRenewVisible] = useState(false);

    const updateSubscription = useCallback(()=>{
        setModalSubscriptionUpdateVisible(true);
    }, [])

    const renewSubscription = useCallback((teamId)=>{
        setModalSubscriptionRenewVisible(true);
    }, [])

    const onTeamSubscriptionUpdated = useCallback(()=>{
        setModalSubscriptionUpdateVisible(false)
        onSubscriptionUpdate && onSubscriptionUpdate();
    }, [teamId])

    const onTeamSubscriptionRenewed = useCallback(()=>{
        setModalSubscriptionRenewVisible(false)
        onSubscriptionUpdate && onSubscriptionUpdate();
    }, [teamId])

    return (
        <TeamSubscriptionContainer className={isInTableViewMode ? 'table-view-mode' : ''}>
            {subscriptionId
                ? <SubscriptionDetails title={title}
                                       price={price}
                                       isActive={isActive}
                                       dateEnd={dateEnd}
                                       services={services}
                                       usedServices={usedServices}
                                       isInTableViewMode={isInTableViewMode} />
                : <SubscriptionPPI />}

            {subscriptionId && (
                <ButtonSecondary style={{width: '100%', margin: '0'}} onClick={renewSubscription}>
                    {t(`team_subscription.btn_renew`)}
                </ButtonSecondary>
            )}

            {hasPermission(user, ['team subscription_change']) && (
                <ButtonSecondary style={{width: '100%', margin: '0'}} onClick={updateSubscription}>
                    {t(`team_subscription.btn_update`)}
                </ButtonSecondary>
            )}

            <ModalSubscriptionUpdate
                isOpen={isModalSubscriptionUpdateVisible}
                teamId={teamId}
                onCancel={()=>setModalSubscriptionUpdateVisible(false)}
                onConfirm={onTeamSubscriptionUpdated}
            />
            {isModalSubscriptionRenewVisible && <ModalSubscriptionRenew
                isOpen={isModalSubscriptionRenewVisible}
                teamId={teamId}
                subscriptionTitle={title}
                subscriptionPrice={price}
                onCancel={()=>setModalSubscriptionRenewVisible(false)}
                onConfirm={onTeamSubscriptionRenewed}
            />}
        </TeamSubscriptionContainer>
    )
}
